import { NotificationService } from '../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ShipmentTransportOrderTrackingMapLoad,
  ShipmentTransportOrderTrackingMapInitialState,
} from './shipment-transport-order-tracking-map.actions';
import { ShipmentTransportOrderTrackingMapService } from './shipment-transport-order-tracking-map.service';
import { ShipmentTransportOrderMapData } from '../../models';
import { Injectable } from '@angular/core';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ShipmentLoadToGpsPointModel } from '../../../../models';

export interface ShipmentTransportOrderTrackingMapStateModel {
  mapData: ShipmentTransportOrderMapData;
  loaded: boolean;
}

const initialState: ShipmentTransportOrderTrackingMapStateModel = {
  mapData: null,
  loaded: false,
};

@State<ShipmentTransportOrderTrackingMapStateModel>({
  name: 'shipmentTransportOrderTrackingMapData',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderTrackingMapState {
  @Selector()
  static getState(state: ShipmentTransportOrderTrackingMapStateModel): ShipmentTransportOrderTrackingMapStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentTransportOrderTrackingMapStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getMapData(state: ShipmentTransportOrderTrackingMapStateModel): ShipmentTransportOrderMapData {
    return state.mapData;
  }

  constructor(
    private shipmentTransportOrderTrackingMapService: ShipmentTransportOrderTrackingMapService,
    private notificationService: NotificationService,
  ) {}

  @Action(ShipmentTransportOrderTrackingMapLoad)
  getShipmentTransportOrderTrackingMapData(
    ctx: StateContext<ShipmentTransportOrderTrackingMapStateModel>,
    { payload }: ShipmentTransportOrderTrackingMapLoad,
  ): Observable<ShipmentTransportOrderMapData | MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentTransportOrderTrackingMapService.getShipmentTransportOrderTrackingMapData(payload).pipe(
      map((mapData: ShipmentTransportOrderMapData) => {
        const gpsPoints = mapData.gpsPoints.map((point: ShipmentLoadToGpsPointModel, index: number) => {
          point.sortIndex = `${index}`;
          return point;
        });
        ctx.patchState({ mapData: { gpsPoints, transportMode: mapData.transportMode }, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderTrackingMapInitialState)
  setInitialState(ctx: StateContext<ShipmentTransportOrderTrackingMapStateModel>): void {
    ctx.setState(initialState);
  }
}
